@if (reportList() !== undefined) {
  @if (!isPrinting()) {
    <app-navigation> </app-navigation>
  } @else {
    <div style="height: 30px"></div>
  }

  <mat-card class="card">
    <mat-card-content>
      <div class="header">
        @if (!isPrinting()) {
          <button class="no-print" mat-stroked-button color="secondary" class="top-navi" routerLink="/patients">
            <mat-icon>arrow_back</mat-icon>Alle Patienten
          </button>
        }
        <div class="middle">
          @if (!isPrinting()) {
            <mat-icon
              class="no-print"
              (click)="onChangeFullPatientDetailsVisibleEnabled()"
              style="cursor: pointer"
              [attr.aria-label]="
                isFullPatientDetailsVisibleEnabled ? 'Details sind sichtbar' : 'Details sind nicht sichtbar'
              ">
              {{ isFullPatientDetailsVisibleEnabled ? 'visibility_off' : 'visibility' }}
            </mat-icon>
          }
          @if (isFullPatientDetailsVisibleEnabled || isPrinting()) {
            <h2>{{ patient()?.name }}, {{ patient() | ageString }}</h2>
          } @else {
            <h2>{{ patient()?.uid }}, {{ patient()?.birthDateIso | decade }}</h2>
          }
          <button class="no-print" mat-button routerLink="../../" title=" Patient bearbeiten">
            <mat-icon title=" Patient bearbeiten">edit</mat-icon>
          </button>
        </div>

        <div class="right-elements no-print">
          @if (tabSelected() === 1) {
            <button class="align-right" mat-flat-button color="primary" (click)="reportComponent.printSimple()">
              Drucken
            </button>
          } @else {
            <button class="align-right neuer-test" mat-flat-button color="primary" (click)="newAssessment()">
              Neue Testung
            </button>
          }
        </div>
      </div>

      <span class="top-buttons no-print">
        <!-- <button mat-button (click)="copyHrefToClipboard()">
          <mat-icon>content_copy</mat-icon> Patienten-link kopieren
        </button> -->
      </span>
    </mat-card-content>

    <mat-tab-group
      #mattab
      (selectedIndexChange)="onTabChange($event)"
      mat-stretch-tabs="false"
      mat-align-tabs="center"
      [@.disabled]="true">
      <mat-tab label="Assessments">
        <ng-template matTabContent>
          <div class="tab-container">
            <app-graph-new [patientId]="patientId"></app-graph-new>
          </div>
        </ng-template>
      </mat-tab>

      <mat-tab label="Bericht">
        <ng-template matTabContent>
          <div class="tab-container do-print">
            <app-report-table
              #reportcomponent
              (isPrinting)="onIsPrintingChanged($event)"
              [patientId]="patientId"></app-report-table>
          </div>
        </ng-template>
      </mat-tab>

      <!-- <mat-tab label="BEFUNDE">
        <div class="tab-container">
          <app-assessment-table-old [patientId]="patientId"></app-assessment-table-old>
        </div>
      </mat-tab> -->
    </mat-tab-group>
  </mat-card>
} @else {
  <app-navigation> </app-navigation>
  <span>Daten werden geladen...</span>
}
